module.exports = {"620503001":"道北街道","620503002":"北道埠街道","620503003":"桥南街道","620503100":"社棠镇","620503101":"马跑泉镇","620503102":"甘泉镇","620503103":"渭南镇","620503104":"东岔镇","620503105":"花牛镇","620503106":"中滩镇","620503107":"新阳镇","620503108":"元龙镇","620503109":"伯阳镇","620503110":"麦积镇","620503111":"石佛镇","620503112":"三岔镇","620503113":"琥珀镇","620503114":"利桥镇","620503115":"五龙镇","620503116":"党川镇","620503400":"天水经济开发区","620503401":"天水市高新技术工业园","620503402":"天水市农业高新技术示范区","620503403":"天水市麦积区三阳工业示范区","620503404":"天水市麦积区廿铺工业示范区","620503405":"天水市麦积区东柯河工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620503.json
// module id = 3047
// module chunks = 0